

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _core = require('../core');

angular.module().run(function () {

    _core.$event.on('$stateChangeStart', function (event) {
        _core.$event.emit('loading');
        _core.$event.emit('loaded');
    });

    var startLoadTime = 0;
    var currentState = 'checkout_init';

    function currentStateName() {
        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
    }

    _core.$event.on('startLoad', function () {

        if (startLoadTime) {
            startLoadTime = _core.$util.now();
        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {

            var performance = window.performance;
            var timing = window.performance.timing || {};
            var now = performance.now();

            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
    });

    _core.$event.on('allLoaded', function () {

        var newState = currentStateName();

        if (!newState) {
            return;
        }

        if (currentState === newState) {
            _core.$event.emit('page_reloaded', currentState);
        } else {

            var duration = void 0;

            if (startLoadTime) {
                duration = _core.$util.now() - startLoadTime;
            }

            var payload = {
                start: currentState,
                end: newState,
                time: duration,
                duration: duration
            };

            _core.$event.emit('$transition', {
                from: currentState,
                toState: _uiRouter.$state.current,
                duration: duration
            });

            _logger.$logger.info('transition', payload);
            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);

            _core.$event.emit('page_loaded', currentState, newState);

            currentState = newState;
        }
    });

    _core.$event.emit('loading');

    var cancel = _core.$event.on('$stateChangeSuccess', function () {
        if (_uiRouter.$state.current.template) {
            cancel();
            setTimeout(function () {
                _core.$event.emit('loaded');
            }, 50);
        }
    });
});

_uiRouter.$state;

_logger.$logger;

_core.$event;

_core.$util;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/ng/events.js
 ** module id = 142
 ** module chunks = 1
 **/